(ns portal.third-party-credentials.cm360-table
  (:require ["@mui/material/SvgIcon$default" :as SvgIcon]
            ["@mui/x-data-grid-premium" :refer [DataGridPremium GridActionsCellItem]]
            ["src/svg/files_folders/bin.svg$default" :as Bin]
            ["src/svg/wpp/content-actions/edit.svg$default" :as Edit]
            [cljs-bean.core :refer [->clj]]
            [common.queries :refer [use-mutation use-query]]
            [common.resource.query.cm360-settings :as cm360.q]
            [common.widgets.data-grid :as dg]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui cm360-edit-action [{:keys [row]}]
  ($ GridActionsCellItem
     {:icon ($ SvgIcon {:inheritViewBox true :component Edit})
      :label "Edit"
      :onClick #(rf/dispatch [:ocp/open {:id :social/config
                                         :props {:type :cm360
                                                 :account row}}])}))

(defui cm360-delete-action [_]
  (let [{:keys [advertiser-id]} (use-subscribe [:url-context])
        {delete-config :mutate}
        (use-mutation (cm360.q/delete-cm360-account-mutation advertiser-id))]
    ($ GridActionsCellItem
       {:icon ($ SvgIcon {:component Bin})
        :label "Delete"
        :onClick delete-config})))

(def ^:private columns
  #js [#js {:field "cc-account-id"
            :headerName "CM360 CC Vault Account"
            :flex 2
            :valueGetter (fn [_v row] (:cc-account-id row))}
       #js {:field "cm360-profile-id"
            :headerName "CM360 Profile ID"
            :flex 2
            :valueGetter (fn [_v row] (:cm360-profile-id row))}
       #js {:field "cm360-advertiser-id"
            :headerName "CM360 Advertiser ID"
            :flex 2
            :valueGetter (fn [_v row] (:cm360-advertiser-id row))}
       #js {:field "actions"
            :type "actions"
            :getActions (fn [^js params]
                          (let [row (.-row params)]
                            #js [($ cm360-edit-action {:row row})
                                 ($ cm360-delete-action)]))}])

(defui cm360-table []
  (let [{:keys [advertiser-id]} (use-subscribe [:url-context])
        {account :data loading :isLoading}
        (use-query (cm360.q/cm360-account-query advertiser-id))
        rows (if (and (not loading) account)
               (to-array [(assoc (->clj account) :id advertiser-id)])
               #js [])]
    ($ DataGridPremium
       {:columns columns
        :rows rows
        :loading loading
        :getRowId (fn [row] (:id row))
        :autoHeight true
        :disableRowSelectionOnClick true
        :localeText #js {:noRowsLabel "No CM360 credentials configured"}
        :sx (clj->js dg/actions-column-sx)})))
